<template>
  <div>
    <section class="fix-header">
      选项内容
      <i
        class="el-icon-circle-plus-outline"
        @click="addOptionsItem"
      />
    </section>
    <el-checkbox-group v-model="selectVal.defaultValue">
      <el-checkbox
        v-for="(item, index) in selectVal.addOptions"
        :key="item.value"
        :label="item.value"
        class="checkbxo-item"
      >
        <el-input
          v-model="item.label"
          placeholder="请输入内容"
        />
        <span @click="deleteOptions(index)"><i class="el-icon-delete" /></span>
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
import { getRandwords } from '@/utils'
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SPCheckboxConfig',
  mixins: [mixin],
  data () {
    return {
      selectVal: {
        addOptions: [],
        defaultValue: []
      }
    }
  },
  methods: {
    addOptionsItem () {
      console.log('SPCheckboxConfig:this.options1',this)
      console.log('SPCheckboxConfig:this.options2',this.options)
      this.selectVal.addOptions.push({
        label: '',
        value: `checkbox_id_${getRandwords()}`
      })
    },
    deleteOptions (index) {
      this.selectVal.addOptions.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.fix-header {
  margin-bottom: 15px;
  font-size: 14px;
  .el-icon-circle-plus-outline {
    font-size: 20px;
    color: #409eff;
  }
}
.checkbxo-item {
  margin-bottom: 10px;
}
</style>
